import ApolloClient, { InMemoryCache } from 'apollo-boost';
import { InMemoryCache as UploadInMemoryCache } from 'apollo-cache-inmemory';

const apolloCache = new UploadInMemoryCache({ addTypename: false });
const { NODE_ENV, REACT_APP_LOCAL_DB } = process.env;

let accountNodeUrl;
switch (REACT_APP_LOCAL_DB) {
  case 'local':
    accountNodeUrl = 'https://subscriptionx-dev-api.ifca.io/subscriptionx'; // local for dev
    // accountNodeUrl = 'https://subscriptionx-api.ifca.asia/subscriptionx'; // staging
    break;
  case 'report':
    accountNodeUrl = 'https://subscriptionx-dev-api.ifca.io/subscriptionx';
    break;
  case 'server':
    accountNodeUrl = 'https://subscriptionx-dev-api.ifca.io/subscriptionx';
    break;
  case 'azure':
    accountNodeUrl = 'https://subscriptionx-dev-api.ifca.io/subscriptionx';
    break;
  case 'staging':
    accountNodeUrl = 'https://subscriptionx-api.ifca.asia/subscriptionx';
    break;
  case 'uat':
    accountNodeUrl = 'https://subscriptionx-api.ifca.asia/subscriptionx';
    break;
  case 'demo':
    accountNodeUrl = 'https://subscriptionx-api.ifca.asia/subscriptionx';
    break;
  default:
    accountNodeUrl = 'https://subscriptionx-api.ifca.asia/subscriptionx';
    break;
}

export const AccountClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  credentials: 'include',
  uri: accountNodeUrl,
  onError: error => {
    error.graphQLErrors?.map(({ message }) => {
      console.log('message', message);
      if (message === 'session can not be established') {
        // browserHistory.push('/login', {})
      }
    });
  },
});
/////////////////////////////////////////////////////////////////////////////////////////
// @access-control-node
export const accessControlUrl =
  NODE_ENV === 'development'
    ? 'http://localhost:5020/access-control'
    : 'https://ifca.io/access-control';

export const AccessControlClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  credentials: 'omit',
  uri: accessControlUrl,
});

/////////////////////////////////////////////////////////////////////////////////////////
// @subcontract-node URL
export const subContractUrl =
  NODE_ENV === 'development'
    ? 'http://localhost:4400/contract-subcontract-graphql'
    : 'https://ifca.io/subcontractx';

// @subcontract-node CLIENT
export const SubcontractClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  credentials: 'omit',
  uri: subContractUrl,
  onError: error => {
    error.graphQLErrors?.map(({ message }) => {
      console.log('message', message);
      if (message === 'session can not be established') {
        // browserHistory.push('/login', {})
      }
    });
  },
});

/////////////////////////////////////////////////////////////////////////////////////////
// @supplier-node URL
export const supplierNodeUrl =
  NODE_ENV === 'development'
    ? 'http://localhost:4800/supplier-graphql'
    : 'https://ifca.io/supplierx';

// @supplier-node CLIENT
export const SupplierClient = new ApolloClient({
  cache: new InMemoryCache({ addTypename: false }),
  credentials: 'omit',
  uri: supplierNodeUrl,
  onError: error => {
    error.graphQLErrors?.map(({ message }) => {
      console.log('message', message);
      if (message === 'session can not be established') {
        // browserHistory.push('/login', {})
      }
    });
  },
});

/////////////////////////////////////////////////////////////////////////////////

// export const uploadLink = createUploadLink({
//   uri: contractNodeUrl, // Apollo Server is served from port 4000

//   request: operation => {
//     const accessToken = getAccessToken();
//     operation.setContext({
//       headers: {
//         'keep-alive': 'true',
//         authorization: `bearer ${accessToken}`,
//       },
//     });
//   },
// });

// const requestLink = new ApolloLink(
//   (operation, forward) =>
//     new Observable(observer => {
//       let handle: any;
//       Promise.resolve(operation)
//         .then(operation => {
//           const accessToken = getAccessToken();
//           if (accessToken) {
//             operation.setContext({
//               headers: {
//                 authorization: `bearer ${accessToken}`,
//               },
//             });
//           }
//         })
//         .then(() => {
//           handle = forward(operation).subscribe({
//             next: observer.next.bind(observer),
//             error: observer.error.bind(observer),
//             complete: observer.complete.bind(observer),
//           });
//         })
//         .catch(observer.error.bind(observer));

//       return () => {
//         if (handle) handle.unsubscribe();
//       };
//     }),
// );
